
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AuthLoading } from "./AuthLoading";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log("ProtectedRoute: Loading:", loading, "User:", user?.id);

  if (loading) {
    return <AuthLoading />;
  }

  if (!user?.id || typeof user.id !== 'string' || user.id.trim() === '') {
    console.log("ProtectedRoute: No valid user ID, redirecting to login");
    // Store current path for redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
